import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 19.5V30a1.5 1.5 0 0 0 1.5 1.5h14v-12h6v12h3A1.5 1.5 0 0 0 29 30V19.5l-13-13Zm10.5 6h-6v-6h6Zm18.094-9.52.004-.003L26 10.379V6a1.5 1.5 0 0 0-3 0v1.379l-5.902-5.902a1.513 1.513 0 0 0-.934-.47h-.004C16.105 1.005 16.055 1 16 1c-.426 0-.809.176-1.082.46L.461 15.919c-.399.371-.566.93-.438 1.457.13.531.536.945 1.063 1.09a1.499 1.499 0 0 0 1.469-.399v.004L16 4.621l13.477 13.477.003-.004c.278.261.641.406 1.02.406A1.5 1.5 0 0 0 32 17c0-.395-.156-.754-.406-1.02Zm0 0",
		style: {
			stroke: "none",
			fillOpacity: 1
		}
	})
});
export default SvgHome;
